import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../auth/services/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { NavigationService } from '../services/navigation.service';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'ch-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  private show: boolean;

  constructor(private authService: AuthService, private router: Router, private navigationService: NavigationService) {}

  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .subscribe(_ => {
        this.navigationService.showSidebar.next(false);
      });

    this.navigationService.showSidebar.subscribe((show: boolean) => {
      this.show = show;
    });
  }

  public logout() {
    this.authService.logout().then(() => {
      this.router.navigateByUrl('/login');
    });

    return false;
  }

  public toggleSideBar() {
    this.navigationService.showSidebar.next(!this.show);
  }

  public goToMember(memberId: string) {
    this.router.navigateByUrl(`/admin/members/edit?id=${memberId}`);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/header/header.component.ts